import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/icon_top_bar_bottom_arrow.png';
import _imports_1 from '@/assets/images/icon_exit_login.png';
const _hoisted_1 = {
  class: "flex align-center c-pointer"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "fz-14 cl-000 ml-8 mr-8"
};
import { useStore } from '@/store';
import { UserActionTypes } from '@/store/modules/user/action-types';
import { onMounted, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'user-bar',
  setup(__props) {
    const storeM = useStore();
    const avatar = ref();
    const userName = ref();
    onMounted(() => {
      getUserInfo();
    });
    const getUserInfo = async () => {
      await storeM.dispatch(UserActionTypes.ACTION_GET_USER_INFO);
      avatar.value = storeM.state.user.avatar;
      userName.value = storeM.state.user.name;
    };
    const handleCommand = command => {
      // ElMessage(`click on item ${command}`)
      if (command === 'exit') {
        exitLogin();
      }
    };
    const exitLogin = () => {
      storeM.dispatch(UserActionTypes.ACTION_LOGIN_OUT);
    };
    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dropdown, {
        onCommand: handleCommand
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "exit"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
              class: "flex align-center"
            }, [_createElementVNode("img", {
              src: _imports_1,
              class: "exit_login_img"
            }), _createElementVNode("span", {
              class: "fz-14 cl-333 ml-6"
            }, "退出登录")], -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
          src: avatar.value ? avatar.value : '@/assets/images/icon_default_avatar.png',
          class: "avatar"
        }, null, 8, _hoisted_2), _createElementVNode("span", _hoisted_3, _toDisplayString(userName.value), 1), _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_0,
          class: "arrow"
        }, null, -1))])]),
        _: 1
      })]);
    };
  }
});